import '../../components.theme/lightbox/lightbox';
import './lightbox.scss';
